const guideIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2ZM6 4h5v8l-2.5-1.5L6 12V4Zm2 14v-5h8v5H8Z"/></svg>'

export const guideFooterMenu = {
  href: "/guide",
  label: "Hướng dẫn sử dụng",
  icon: guideIcon
}
